export default __webpack_public_path__ + "static/media/product-10.443c6465.jpg";